import "./Loader.css";
export default function Loader(){
    return <div class="loader">
        <h3>Loading Pokemon!</h3>
        <img src="img/Pokeball.png" className="loader-img" />
    </div>
}